import auth0, { LogoutOptions } from 'auth0-js'

class Auth0 {
	auth0
	constructor() {
		this.auth0 = new auth0.WebAuth({
			domain: process.env.REACT_APP_AUTH0_DOMAIN as string,
			clientID: process.env.REACT_APP_AUTH0_CLIENT_ID as string,
			responseType: 'token profile email user_id last_password_reset',
			redirectUri: window.location.origin,
			scope: 'openid profile email user_id create:user_tickets',
		})
	}

	login(username: string, password: string): Promise<any> {
		return new Promise((resolve, reject) => {
			this.auth0.client.login(
				{
					realm: process.env.REACT_APP_AUTH0_REALM as string,
					username,
					password,
				},
				(error, result) => {
					result && resolve(result)
					error && reject(error)
				}
			)
		})
	}

	logout(options: LogoutOptions): void {
		this.auth0.logout(options)
	}
}

const auth0Client = new Auth0()

export default auth0Client
